import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// Facebook Pixel helper
const fbq = (...args: any[]) => {
  const w = window as any;
  if (w.fbq) w.fbq(...args);
};
const CHECKOUT_GUIDE_ONLY_URL = 'https://betterdailyguides.com/cart/51925823750446:1';
// Checkout URL map based on selected bonus combinations
const checkoutUrlMap: Record<string, string> = {
  '': CHECKOUT_GUIDE_ONLY_URL,
  bonus1: 'https://betterdailyguides.com/cart/51947100766510:1',
  bonus2: 'https://betterdailyguides.com/cart/51947104239918:1',
  bonus3: 'https://betterdailyguides.com/cart/51947106500910:1',
  bonus4: 'https://betterdailyguides.com/cart/51947110301998:1',
  'bonus1,bonus2': 'https://betterdailyguides.com/cart/51947113349422:1',
  'bonus1,bonus3': 'https://betterdailyguides.com/cart/51947113447726:1',
  'bonus1,bonus4': 'https://betterdailyguides.com/cart/51947116724526:1',
  'bonus2,bonus3': 'https://betterdailyguides.com/cart/51947120558382:1',
  'bonus2,bonus4': 'https://betterdailyguides.com/cart/51947117412654:1',
  'bonus3,bonus4': 'https://betterdailyguides.com/cart/51947117773102:1',
  'bonus1,bonus2,bonus3': 'https://betterdailyguides.com/cart/51947123736878:1',
  'bonus1,bonus2,bonus4': 'https://betterdailyguides.com/cart/51947125899566:1',
  'bonus1,bonus3,bonus4': 'https://betterdailyguides.com/cart/51947127931182:1',
  'bonus2,bonus3,bonus4': 'https://betterdailyguides.com/cart/51947128488238:1',
  'bonus1,bonus2,bonus3,bonus4': 'https://betterdailyguides.com/cart/51947128750382:1'
};
function getCheckoutUrl(selected: Set<string>): string {
  const key = Array.from(selected).sort().join(',');
  return checkoutUrlMap[key] || CHECKOUT_GUIDE_ONLY_URL;
}
const bonuses = [{
  id: 'bonus1',
  num: 'Bono 1',
  icon: '🌙',
  title: 'Noches Doradas',
  oldPrice: '$57',
  price: 5.0
}, {
  id: 'bonus2',
  num: 'Bono 2',
  icon: '🧠',
  title: 'Pequeño Genio',
  oldPrice: '$37',
  price: 5.0
}, {
  id: 'bonus3',
  num: 'Bono 3',
  icon: '📅',
  title: 'Tu Bebé Mes a Mes',
  oldPrice: '$27',
  price: 5.0
}, {
  id: 'bonus4',
  num: 'Bono 4',
  icon: '💰',
  title: 'Ahorra $2000',
  oldPrice: '$17',
  price: 5.0
}];
interface BonusesSectionProps {
  onBuyClick?: (e: React.MouseEvent) => void;
}
type PopupType = 'no-bonus' | 'almost-all' | null;
export function BonusesSection({
  onBuyClick
}: BonusesSectionProps) {
  const [selectedBonuses, setSelectedBonuses] = useState<Set<string>>(new Set());
  const [activePopup, setActivePopup] = useState<PopupType>(null);
  const toggleBonus = (id: string) => {
    const newSelected = new Set(selectedBonuses);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
      // Fire AddToCart when a bonus is added
      const bonus = bonuses.find(b => b.id === id);
      if (bonus) {
        fbq('track', 'AddToCart', {
          content_name: bonus.title,
          content_type: 'product',
          value: bonus.price,
          currency: 'USD'
        });
      }
    }
    setSelectedBonuses(newSelected);
  };
  const basePrice = 6.39;
  const bonusesTotal = selectedBonuses.size * 5;
  const isAllSelected = selectedBonuses.size === bonuses.length;
  const rawTotal = basePrice + bonusesTotal;
  const finalTotal = isAllSelected ? 13.2 : rawTotal;
  // Find the missing bonuses when not all are selected
  const missingBonuses = bonuses.filter(b => !selectedBonuses.has(b.id));
  const missingBonus = missingBonuses.length > 0 ? missingBonuses[0] : null;
  const handleCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    if (selectedBonuses.size === 0) {
      setActivePopup('no-bonus');
      return;
    }
    if (selectedBonuses.size > 0 && selectedBonuses.size < 4) {
      setActivePopup('almost-all');
      return;
    }
    fbq('track', 'InitiateCheckout', {
      content_name: 'Protocolo B.E.BE 365 + 4 Bonos',
      value: finalTotal,
      currency: 'USD',
      num_items: selectedBonuses.size + 1
    });
    const url = getCheckoutUrl(selectedBonuses);
    window.location.href = url;
  };
  const handleConfirmNoBonuses = () => {
    fbq('track', 'InitiateCheckout', {
      content_name: 'Protocolo B.E.BE 365 (Solo Guía)',
      value: 6.39,
      currency: 'USD',
      num_items: 1
    });
    window.location.href = CHECKOUT_GUIDE_ONLY_URL;
  };
  const handleClosePopup = () => {
    setActivePopup(null);
  };
  // Add missing bonuses and go to all-4 checkout
  const handleAddMissingBonus = () => {
    const allSelected = new Set(selectedBonuses);
    missingBonuses.forEach(b => allSelected.add(b.id));
    setSelectedBonuses(allSelected);
    setActivePopup(null);
    fbq('track', 'InitiateCheckout', {
      content_name: 'Protocolo B.E.BE 365 + 4 Bonos (50% OFF)',
      value: 13.2,
      currency: 'USD',
      num_items: 5
    });
    window.location.href = checkoutUrlMap['bonus1,bonus2,bonus3,bonus4'];
  };
  // Continue with current partial selection
  const handleContinueWith3 = () => {
    fbq('track', 'InitiateCheckout', {
      content_name: `Protocolo B.E.BE 365 + ${selectedBonuses.size} Bonos`,
      value: finalTotal,
      currency: 'USD',
      num_items: selectedBonuses.size + 1
    });
    const url = getCheckoutUrl(selectedBonuses);
    window.location.href = url;
  };
  // ── No-Bonus Popup state ──
  const [popupSelected, setPopupSelected] = useState<Set<string>>(new Set());
  const togglePopupBonus = (id: string) => {
    const newSelected = new Set(popupSelected);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setPopupSelected(newSelected);
  };
  const popupBonusesTotal = popupSelected.size * 5;
  const popupIsAllSelected = popupSelected.size === bonuses.length;
  const popupRawTotal = basePrice + popupBonusesTotal;
  const popupFinalTotal = popupIsAllSelected ? 13.2 : popupRawTotal;
  const handlePopupCheckout = () => {
    if (popupSelected.size === 0) {
      fbq('track', 'InitiateCheckout', {
        content_name: 'Protocolo B.E.BE 365 (Solo Guía)',
        value: 6.39,
        currency: 'USD',
        num_items: 1
      });
      window.location.href = CHECKOUT_GUIDE_ONLY_URL;
      return;
    }
    fbq('track', 'InitiateCheckout', {
      content_name: `Protocolo B.E.BE 365 + ${popupSelected.size} Bonos`,
      value: popupFinalTotal,
      currency: 'USD',
      num_items: popupSelected.size + 1
    });
    const url = getCheckoutUrl(popupSelected);
    window.location.href = url;
  };
  return <>
      <section id="bonuses" className="bg-white py-6 md:py-16 px-4 md:px-5" data-id="element-26">
        <div className="max-w-[900px] mx-auto" data-id="element-27">
          <h2 className="text-2xl md:text-4xl text-[#3D2B1F] mb-1 md:mb-4 leading-tight text-center font-bold" data-id="element-28">
            Agrega tus Bonos
          </h2>

          <p className="text-sm md:text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-3 md:mb-10" data-id="element-29">
            <strong className="text-[#B76E79]" data-id="element-30">
              ¡Lleva los 4 y obtén 50% OFF!
            </strong>
          </p>

          <div className="flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-5 mb-4 md:mb-10" data-id="element-31">
            {bonuses.map(bonus => {
            const isSelected = selectedBonuses.has(bonus.id);
            return <motion.div key={bonus.id} whileTap={{
              scale: 0.97
            }} onClick={() => toggleBonus(bonus.id)} className={`cursor-pointer rounded-xl md:rounded-2xl px-3 py-2.5 md:p-5 border-2 transition-all flex items-center gap-3 md:flex-col md:items-start md:h-full ${isSelected ? 'bg-gradient-to-r md:bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] border-[#B76E79] shadow-md' : 'bg-white border-gray-200'}`} data-id="element-32">
                  <div className="w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors md:absolute md:top-5 md:right-5" style={{
                borderColor: isSelected ? '#B76E79' : '#D1D5DB',
                backgroundColor: isSelected ? '#B76E79' : 'transparent'
              }} data-id="element-33">
                    {isSelected && <span className="text-white text-sm font-bold" data-id="element-34">✓</span>}
                  </div>

                  <span className="text-xl md:text-3xl flex-shrink-0" data-id="element-35">
                    {bonus.icon}
                  </span>

                  <div className="flex-1 min-w-0 flex items-center justify-between md:flex-col md:items-start md:gap-2" data-id="element-36">
                    <div className="flex items-center gap-1.5 min-w-0" data-id="element-37">
                      <span className={`text-xs md:text-[11px] font-bold px-1.5 py-0.5 rounded font-sans tracking-wide flex-shrink-0 ${isSelected ? 'bg-[#B76E79] text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-38">
                        {bonus.num}
                      </span>
                      <span className="text-base md:text-lg font-bold text-[#3D2B1F] truncate" data-id="element-39">
                        {bonus.title}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 flex-shrink-0 ml-2 md:ml-0" data-id="element-40">
                      <span className="text-sm md:text-xs text-gray-400 line-through font-sans" data-id="element-41">
                        {bonus.oldPrice}
                      </span>
                      <span className={`text-base md:text-lg font-bold font-sans ${isSelected ? 'text-[#B76E79]' : 'text-green-600'}`} data-id="element-42">
                        $5
                      </span>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>

          {/* Summary + CTA */}
          <div className="bg-[#FAF7F2] rounded-2xl md:rounded-3xl p-4 md:p-8 border-2 border-[rgba(183,110,121,0.2)] shadow-xl relative overflow-hidden" data-id="element-43">
            <AnimatePresence data-id="element-44">
              {isAllSelected && <motion.div initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} className="absolute top-0 left-0 right-0 bg-gradient-to-r from-[#C9A96E] via-[#B76E79] to-[#C9A96E] text-white text-center py-1 text-xs font-bold tracking-widest uppercase font-sans" data-id="element-45">
                  🎉 ¡50% OFF APLICADO! 🎉
                </motion.div>}
            </AnimatePresence>

            <div className={`flex flex-col items-center gap-3 md:flex-row md:justify-between md:gap-6 ${isAllSelected ? 'mt-3 md:mt-4' : ''}`} data-id="element-46">
              <div className="flex items-center gap-2 md:flex-col md:items-start" data-id="element-47">
                <span className="text-sm text-[#6B4C3B] font-sans" data-id="element-48">
                  Protocolo $6.39
                  {selectedBonuses.size > 0 && ` + ${selectedBonuses.size} bono${selectedBonuses.size !== 1 ? 's' : ''}`}{' '}
                  =
                </span>
                <div className="flex items-end gap-2" data-id="element-49">
                  {isAllSelected && <span className="text-lg md:text-2xl text-gray-400 line-through font-bold font-sans" data-id="element-50">
                      ${rawTotal.toFixed(2)}
                    </span>}
                  <span className={`text-2xl md:text-4xl font-bold leading-none ${isAllSelected ? 'text-[#B76E79]' : 'text-[#3D2B1F]'}`} data-id="element-51">
                    ${finalTotal.toFixed(2)}
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-2 w-full md:w-auto md:min-w-[300px]" data-id="element-52">
                <button onClick={handleCheckout} className="w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-base md:text-lg font-bold py-3 md:py-4 px-6 md:px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse border-none cursor-pointer" data-id="element-53">
                  ⚡ OBTENER ACCESO POR ${finalTotal.toFixed(2)} →
                </button>

                <button onClick={handleConfirmNoBonuses} className="w-full text-xs text-gray-500 font-sans hover:text-[#B76E79] transition-colors underline underline-offset-2 text-center bg-transparent border-none cursor-pointer" data-id="element-54">
                  No gracias, continuar sin bonos →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ POPUP: No bonuses selected ═══ */}
      <AnimatePresence data-id="element-55">
        {activePopup === 'no-bonus' && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[10001] bg-black/70 flex items-center justify-center p-4" onClick={handleClosePopup} data-id="element-56">
            <motion.div initial={{
          scale: 0.85,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.85,
          opacity: 0,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 20,
          stiffness: 300
        }} className="bg-[#FAF7F2] rounded-2xl max-w-[420px] w-full relative overflow-hidden shadow-2xl" style={{
          boxShadow: '0 0 0 3px rgba(201, 169, 110, 0.3), 0 25px 60px rgba(0,0,0,0.3)'
        }} onClick={e => e.stopPropagation()} data-id="element-57">
              <div className="bg-gradient-to-r from-[#C9A96E] via-[#B76E79] to-[#C9A96E] py-2 px-4 text-center" data-id="element-58">
                <span className="text-white text-xs font-bold tracking-widest uppercase font-sans" data-id="element-59">
                  ⚡ ¡NO TE VAYAS SIN TUS BONOS! ⚡
                </span>
              </div>

              <div className="p-5 text-center" data-id="element-60">
                <div className="text-4xl mb-2" data-id="element-61">🎁</div>

                <h2 className="text-xl font-bold text-[#3D2B1F] leading-tight mb-1" data-id="element-62">
                  ¡Espera! Personaliza tu experiencia
                </h2>

                <p className="text-base text-[#6B4C3B] font-sans mb-4 max-w-[360px] mx-auto" data-id="element-63">
                  No seleccionaste ningún bono. Agrega los que quieras por solo{' '}
                  <strong className="text-[#B76E79]" data-id="element-64">$5 c/u</strong> o{' '}
                  <strong className="text-[#B76E79]" data-id="element-65">
                    lleva los 4 con 50% OFF
                  </strong>
                  .
                </p>

                <div className="flex flex-col gap-1.5 mb-4 max-w-[360px] mx-auto" data-id="element-66">
                  {bonuses.map(bonus => {
                const isSelected = popupSelected.has(bonus.id);
                return <button key={bonus.id} onClick={() => togglePopupBonus(bonus.id)} className={`flex items-center gap-2.5 px-3 py-2 rounded-xl border-2 transition-all text-left cursor-pointer ${isSelected ? 'bg-gradient-to-r from-[#FAF7F2] to-[#F0E8DE] border-[#B76E79]' : 'bg-white border-gray-200 hover:border-gray-300'}`} data-id="element-67">
                        <div className="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0" style={{
                    borderColor: isSelected ? '#B76E79' : '#D1D5DB',
                    backgroundColor: isSelected ? '#B76E79' : 'transparent'
                  }} data-id="element-68">
                          {isSelected && <span className="text-white text-xs font-bold" data-id="element-69">
                              ✓
                            </span>}
                        </div>
                        <span className="text-lg flex-shrink-0" data-id="element-70">
                          {bonus.icon}
                        </span>
                        <span className={`text-xs font-bold px-1.5 py-0.5 rounded font-sans flex-shrink-0 ${isSelected ? 'bg-[#B76E79] text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-71">
                          {bonus.num}
                        </span>
                        <span className="text-sm font-bold text-[#3D2B1F] flex-1 truncate" data-id="element-72">
                          {bonus.title}
                        </span>
                        <div className="flex items-center gap-1 flex-shrink-0" data-id="element-73">
                          <span className="text-xs text-gray-400 line-through" data-id="element-74">
                            {bonus.oldPrice}
                          </span>
                          <span className={`text-sm font-bold ${isSelected ? 'text-[#B76E79]' : 'text-green-600'}`} data-id="element-75">
                            $5
                          </span>
                        </div>
                      </button>;
              })}
                </div>

                <div className="bg-white rounded-xl p-3 border border-gray-200 mb-4" data-id="element-76">
                  <div className="flex items-center justify-center gap-2" data-id="element-77">
                    <span className="text-sm text-[#6B4C3B] font-sans" data-id="element-78">
                      Total:
                    </span>
                    {popupIsAllSelected && <span className="text-base text-gray-400 line-through font-bold font-sans" data-id="element-79">
                        ${popupRawTotal.toFixed(2)}
                      </span>}
                    <span className={`text-2xl font-bold ${popupIsAllSelected ? 'text-[#B76E79]' : 'text-[#3D2B1F]'}`} data-id="element-80">
                      ${popupFinalTotal.toFixed(2)}
                    </span>
                    {popupIsAllSelected && <span className="bg-[#B76E79] text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-81">
                        50% OFF
                      </span>}
                  </div>
                </div>

                <button onClick={handlePopupCheckout} className="w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-base font-bold py-3 px-5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 font-sans uppercase cursor-pointer border-none animate-cta-pulse" data-id="element-82">
                  {popupSelected.size > 0 ? `⚡ OBTENER ACCESO POR $${popupFinalTotal.toFixed(2)} →` : '⚡ CONTINUAR SOLO CON LA GUÍA — $6.39 →'}
                </button>

                <button onClick={handleConfirmNoBonuses} className="mt-3 bg-transparent border-none text-xs text-gray-400 font-sans cursor-pointer hover:text-gray-600 transition-colors underline underline-offset-2" data-id="element-83">
                  No gracias, continuar sin bonos →
                </button>

                <div className="flex justify-center gap-3 flex-wrap mt-3 text-xs text-gray-400 font-sans" data-id="element-84">
                  <span data-id="element-85">🔒 Pago Seguro</span>
                  <span data-id="element-86">📥 Acceso Instantáneo</span>
                  <span data-id="element-87">↩️ Garantía 30 Días</span>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* ═══ POPUP: Partial bonuses selected — remind about 50% OFF ═══ */}
      <AnimatePresence data-id="element-88">
        {activePopup === 'almost-all' && missingBonuses.length > 0 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[10001] bg-black/70 flex items-center justify-center p-4" onClick={handleClosePopup} data-id="element-89">
            <motion.div initial={{
          scale: 0.85,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.85,
          opacity: 0,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 20,
          stiffness: 300
        }} className="bg-[#FAF7F2] rounded-2xl max-w-[400px] w-full relative overflow-hidden shadow-2xl" style={{
          boxShadow: '0 0 0 3px rgba(201, 169, 110, 0.4), 0 25px 60px rgba(0,0,0,0.3)'
        }} onClick={e => e.stopPropagation()} data-id="element-90">
              <div className="bg-gradient-to-r from-[#C9A96E] via-[#B76E79] to-[#C9A96E] py-2 px-4 text-center" data-id="element-91">
                <span className="text-white text-xs font-bold tracking-widest uppercase font-sans" data-id="element-92">
                  🔥 ¡ESTÁS A UN PASO DEL 50% OFF! 🔥
                </span>
              </div>

              <div className="p-5 text-center" data-id="element-93">
                <div className="text-5xl mb-3" data-id="element-94">🎉</div>

                <h2 className="text-xl font-bold text-[#3D2B1F] leading-tight mb-2" data-id="element-95">
                  {selectedBonuses.size === 3 ? '¡Ya tienes 3 bonos!' : selectedBonuses.size === 2 ? '¡Ya tienes 2 bonos!' : '¡Ya tienes 1 bono!'}
                </h2>

                <p className="text-base text-[#6B4C3B] font-sans mb-4 max-w-[340px] mx-auto leading-relaxed" data-id="element-96">
                  Agrega{' '}
                  {missingBonuses.length === 1 ? <strong className="text-[#B76E79]" data-id="element-97">
                      {missingBonuses[0].icon} {missingBonuses[0].title}
                    </strong> : <>
                      {missingBonuses.map((b, i) => <span key={b.id} data-id="element-98">
                          {i > 0 && i < missingBonuses.length - 1 && ', '}
                          {i > 0 && i === missingBonuses.length - 1 && ' y '}
                          <strong className="text-[#B76E79]" data-id="element-99">
                            {b.icon} {b.title}
                          </strong>
                        </span>)}
                    </>}{' '}
                  y desbloquea el{' '}
                  <strong className="text-[#B76E79]" data-id="element-100">50% de descuento</strong>{' '}
                  en todo tu pedido.
                </p>

                {/* Price comparison */}
                <div className="bg-white rounded-xl p-4 border-2 border-[#C9A96E]/30 mb-4 relative" data-id="element-101">
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#B76E79] text-white text-xs font-bold px-3 py-0.5 rounded-full uppercase tracking-wider" data-id="element-102">
                    50% OFF
                  </div>
                  <div className="flex items-center justify-center gap-4" data-id="element-103">
                    <div className="text-center" data-id="element-104">
                      <div className="text-xs text-gray-400 font-sans mb-0.5" data-id="element-105">
                        Sin descuento
                      </div>
                      <div className="text-lg text-gray-400 line-through font-bold font-sans" data-id="element-106">
                        $26.39
                      </div>
                    </div>
                    <div className="text-2xl" data-id="element-107">→</div>
                    <div className="text-center" data-id="element-108">
                      <div className="text-xs text-[#B76E79] font-sans font-bold mb-0.5" data-id="element-109">
                        Con los 4 bonos
                      </div>
                      <div className="text-2xl text-[#B76E79] font-bold font-sans" data-id="element-110">
                        $13.20
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-[#6B4C3B] font-sans mt-2" data-id="element-111">
                    {missingBonuses.length === 1 ? `Solo agrega ${missingBonuses[0].title} por $5 más y ahorra $13.20` : `Agrega ${missingBonuses.length} bonos por $${(missingBonuses.length * 5).toFixed(0)} más y ahorra $13.20`}
                  </p>
                </div>

                {/* Add missing bonuses button */}
                <button onClick={handleAddMissingBonus} className="w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-sm md:text-base font-bold py-3.5 px-5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 font-sans uppercase cursor-pointer border-none animate-cta-pulse" data-id="element-112">
                  {missingBonuses.length === 1 ? `🎁 ¡SÍ! AGREGAR ${missingBonuses[0].title.toUpperCase()} Y OBTENER 50% OFF →` : `🎁 ¡SÍ! AGREGAR ${missingBonuses.length} BONOS Y OBTENER 50% OFF →`}
                </button>

                <button onClick={handleContinueWith3} className="mt-3 w-full bg-gray-100 border border-gray-200 text-[#6B4C3B] text-sm font-medium py-2.5 px-4 rounded-full cursor-pointer hover:bg-gray-200 transition-all font-sans" data-id="element-113">
                  No, continuar con {selectedBonuses.size} bono
                  {selectedBonuses.size !== 1 ? 's' : ''} por $
                  {finalTotal.toFixed(2)} →
                </button>

                <div className="flex justify-center gap-3 flex-wrap mt-3 text-xs text-gray-400 font-sans" data-id="element-114">
                  <span data-id="element-115">🔒 Pago Seguro</span>
                  <span data-id="element-116">📥 Acceso Instantáneo</span>
                  <span data-id="element-117">↩️ Garantía 30 Días</span>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}